import {AfterViewInit, Injectable} from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { DatabaseService } from './database.service';
import {reject} from "q";

@Injectable()
export class AuthenticationService {

  public auth_data: any;
  public admin = 'BY3qoF5iPDeVo4soDS482qSzy7l1';

  constructor(public fire: AngularFireAuth,
              public db: DatabaseService) {
    this.auth_data = localStorage.getItem('auth_data');
  }

  definedAuthData(state: boolean) {
    return new Promise((resolve) => {
      if (state) {
        localStorage.setItem('auth_data', 'loged');
        this.auth_data = localStorage.getItem('auth_data');
        resolve(true);
      } else {
        localStorage.setItem('auth_data', 'unloged');
        this.auth_data = localStorage.getItem('auth_data');
        localStorage.removeItem('devis');
        resolve(true);
      }
    });
  }

  /**
   * Login user
   * @param {Object} user
   * @returns {Promise<any>}
   */
  login(user: object) {
    return this.fire.auth.signInWithEmailAndPassword(user['email'], user['password']);
  }

  /**
   * Register user
   * @param {Object} user
   * @returns {Promise<any>}
   */
  register(user: object) {
    return this.fire.auth.createUserWithEmailAndPassword(user['email'], user['password']);
  }

  /**
   * Check if user is login
   * @returns {Promise<any>}
   */
  islogin() {
    return new Promise((resolve) => {
      this.fire.auth.onAuthStateChanged(function(user) {
        if (user) {
          resolve(user);
        } else {
          resolve();
        }
      });
    });
  }

  /**
   * Logout user
   * @returns {Promise<any>}
   */
  logout() {
    return this.fire.auth.signOut();
  }

  resetPassword(email) {
    return this.fire.auth.sendPasswordResetEmail(email);
  }
}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/providers/authentication.service.ts